import React, { useState } from 'react';
import { TextBox as DXTextBox } from 'devextreme-react/text-box';
import { Validator, RequiredRule } from 'devextreme-react/validator';
import { List } from 'devextreme-react/list';
import '../../scss/controls/_textbox.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

interface DropBoxProps {
    value: string;
    readOnly?: boolean;
    onChange: (value: string) => void;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    validator?: React.ReactNode;
    dropdownItems?: string[];
}

export const DropBox: React.FC<DropBoxProps> = ({
    value,
    readOnly = false,
    onChange,
    label,
    helperText,
    required = false,
    children,
    validator,
    dropdownItems,
}) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const handleValueChanged = (e: any) => {
        onChange(e.value);
    };

    const toggleDropdown = () => {
        setDropdownVisible((prev) => !prev);
    };

    const handleItemClick = (e: any) => {
        onChange(e.itemData);
        setDropdownVisible(false);
    };

    return (
        <div className='textbox-container'>
            {label && <label className='textbox-label'>{label}</label>}
            <div
                className='textbox-wrapper'
                style={{ position: 'relative' }}
            >
                <DXTextBox
                    value={value}
                    readOnly={readOnly}
                    onValueChanged={handleValueChanged}
                    className='textbox-input'
                >
                    <Validator>
                        {required && <RequiredRule message='This field is required' />}
                        {validator}
                    </Validator>
                </DXTextBox>

                {/* Show the dropdown arrow if dropdownItems is provided and textbox is not read-only */}
                {dropdownItems && !readOnly && (
                    <div
                        className='textbox-dropdown-arrow'
                        onClick={toggleDropdown}
                    >
                        <FontAwesomeIcon
                            icon={dropdownVisible ? faChevronUp : faChevronDown}
                            aria-hidden='true'
                        ></FontAwesomeIcon>
                    </div>
                )}
                {dropdownItems && dropdownVisible && (
                    <div className='textbox-dropdown-list'>
                        <List
                            dataSource={dropdownItems}
                            onItemClick={handleItemClick}
                            hoverStateEnabled={true}
                            height={120}
                        />
                    </div>
                )}
            </div>
            {helperText && <div className='textbox-helper'>{helperText}</div>}
            {children && <div className='textbox-children'>{children}</div>}
        </div>
    );
};
